import React from 'react';
import { Box, SpaceBetween } from '@amzn/awsui-components-react';

/** Legend of the reference styles in Step 2 totals and Step 3 formulas: Step 1 data sources and Step 2 totals. */
export default function DasExpressionLegend() {
    return (
        <Box color="text-body-secondary" data-class="dasExpressionLegend">
            <SpaceBetween direction="horizontal" size="xs">
                <span>Legend:</span>
                <span className="calcExpression-D">Step-1 data source</span>
                <span className="calcExpression-S">Step-2 total</span>
            </SpaceBetween>
        </Box>
    );
}
